import { Keyring } from '@polkadot/keyring';
import { cryptoWaitReady } from '@polkadot/util-crypto';
import { Wallet } from 'ethers';
import { CERE_SS58_PREFIX, type KeystoreEncryptor } from '@cef-ai/wallet-identity';

/**
 * SPA-side keystore encoder injected into `IdentityImpl` via `createIdentity`.
 * The heavy keystore libraries live here (SPA bundle) so the published identity
 * package stays dependency-free. Pure: given raw key bytes it returns encrypted
 * keystore JSON and retains nothing.
 *
 * - `cere` → Polkadot ed25519 keystore (scrypt + xsalsa20-poly1305), SS58
 *   prefix 54 — the exact format `@cere-ddc-sdk/ddc-client` `JsonSigner`,
 *   `@polkadot/keyring.addFromJson`, and the hiring-coach scripts already load.
 * - `evm` → Ethereum V3 keystore (scrypt + aes-128-ctr), importable by MetaMask.
 */
export const spaKeystoreEncryptor: KeystoreEncryptor = async (chain, keyBytes, passphrase, _address) => {
  if (chain === 'cere') {
    await cryptoWaitReady();
    const keyring = new Keyring({ type: 'ed25519', ss58Format: CERE_SS58_PREFIX });
    const pair = keyring.addFromSeed(keyBytes);
    return JSON.stringify(pair.toJson(passphrase));
  }
  // evm
  const hex = '0x' + Buffer.from(keyBytes).toString('hex');
  const wallet = new Wallet(hex);
  return wallet.encrypt(passphrase);
};
